import { useConsentManager } from "@c15t/react";
import { useCallback, useState } from "react";

import Button from "client/common/components/buttons/Button";
import TextButton from "client/common/components/buttons/TextButton";
import { urls } from "client/routes";

import { useConsentBannerMutation } from "../hooks";
import { ConsentPreferencesDialog } from "./ConsentPreferencesDialog";

import styles from "../styles/ConsentBanner.module.less";

export const ConsentBanner = () => {
  const { showPopup, saveConsents } = useConsentManager();
  const { mutate: syncBannerConsent } = useConsentBannerMutation();
  const [showPreferencesDialog, setShowPreferencesDialog] = useState(false);

  const handleAcceptAll = useCallback(() => {
    saveConsents("all");

    syncBannerConsent({
      experience: true,
      functionality: true,
      marketing: true,
    });
  }, [saveConsents, syncBannerConsent]);

  if (!showPopup && !showPreferencesDialog) {
    return null;
  }

  if (showPreferencesDialog) {
    return <ConsentPreferencesDialog onClose={() => setShowPreferencesDialog(false)} />;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div>
          <h2 className={styles.title}>We value your privacy</h2>
          <p className={styles.description}>
            We use cookies and similar technologies to enhance your browsing experience and analyze
            our traffic. By clicking accept, you agree to our use of these technologies, as outlined
            in our{" "}
            <TextButton dest={urls.support.privacyPolicy()} hasUnderline={true}>
              Privacy Policy
            </TextButton>
            .
          </p>
        </div>
        <div className={styles.actions}>
          <Button
            variant="secondary"
            size="xs"
            className={styles.action}
            onClick={() => setShowPreferencesDialog(true)}
          >
            Your privacy choices
          </Button>
          <Button variant="primary" size="xs" className={styles.action} onClick={handleAcceptAll}>
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
};
